import { Box, Grid, Skeleton, Tab, Tabs } from "@mui/material";
import { Icons, Images } from "assets";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useDebounce from "shared/customHooks/useDebounce";
import { routeConstant } from "shared/routes/routesConstant";
import styles from "./style.module.scss";
import useBreadcrumbs from "shared/customHooks/useBreadCrumbs";

function SearchPartners() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const text: any = queryParams.get("text");
  const [search, setSearch] = useState<string>(text);
  const [searchText, setSearchText] = useState<string>(text);
  const [activeTab, setActiveTab] = useState<any>(0);
  const [loader, setLoader] = useState<boolean>(false);

  useDebounce(
    () => {
      const trimmedSearch = (search || "").trim();
      // Nothing changed once trimmed (e.g. only spaces were typed) — skip the
      // re-navigate and the loader entirely.
      if (trimmedSearch === searchText) return;
      setSearchText(trimmedSearch);
      setLoader(true);
      setTimeout(() => {
        setLoader(false);
      }, 1000);
    },
    [search],
    800
  );

  useEffect(() => {
    navigate({
      pathname: routeConstant.partnerListings.path,
      search: `?text=${searchText}`,
    });
    // eslint-disable-next-line
  }, [searchText]);

  const handleChange = (event: any, newValue: number) => {
    setActiveTab(newValue);
    setLoader(true);
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  };

  const tabs = [
    {
      value: 0,
      label: "Publishers Accounts",
    },
    {
      value: 1,
      label: "Authors Accounts",
    },
  ];

  const tabsEnum = {
    publishers: 0,
    authors: 1,
  };

  const publishers = [
    {
      name: "John Watts",
      publishingHouse: "Jenkins Publishers",
      books: 0,
      linked: 0,
    },
    {
      name: "Peter Parker",
      publishingHouse: "Marvel Comics",
      books: 980,
      linked: 0,
    },
    {
      name: "Lamine Yamal",
      publishingHouse: "JK HP House",
      books: 430,
      linked: 0,
    },
    {
      name: "Bruce Banner",
      publishingHouse: "Marvel Comics",
      books: 90,
      linked: 5,
    },
    {
      name: "Phil Dunphy",
      publishingHouse: "Modern Family House",
      books: 30,
      linked: 0,
    },
    {
      name: "Nick Miller",
      publishingHouse: "LA Publishers",
      books: 890,
      linked: 0,
    },
    {
      name: "Morris Lamorne",
      publishingHouse: "LA Publishers",
      books: 781,
      linked: 0,
    },
    {
      name: "Pattrick Johnson",
      publishingHouse: "RMFC",
      books: 410,
      linked: 0,
    },
  ];

  const authors = [
    {
      name: "John Watts",
      publishingHouse: "Jenkins Publishers",
      books: 0,
      linked: 0,
    },
    {
      name: "Peter Parker",
      publishingHouse: "Marvel Comics",
      books: 980,
      linked: 0,
    },
    {
      name: "Lamine Yamal",
      books: 430,
      linked: 0,
    },
    {
      name: "Bruce Banner",
      publishingHouse: "Marvel Comics",
      books: 90,
      linked: 5,
    },
    {
      name: "Phil Dunphy",
      publishingHouse: "Modern Family House",
      books: 30,
      linked: 0,
    },
    {
      name: "Nick Miller",
      publishingHouse: "LA Publishers",
      books: 890,
      linked: 0,
    },
    {
      name: "Morris Lamorne",
      books: 781,
      linked: 0,
    },
    {
      name: "Pattrick Johnson",
      books: 410,
      linked: 0,
    },
  ];

  useEffect(() => {
    setLoader(true);
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  }, []);

  useBreadcrumbs(
    {
      title: "Search Partners",
      path: routeConstant?.partnerListings?.path,
    },
    true
  );

  return (
    <div className={styles.mainContainer}>
      <Grid container>
        <Grid xs={12} md={6} sx={{ display: "flex", alignItems: "center" }}>
          <span className={styles.heading}>
            {searchText?.length
              ? `Search Results for "${searchText}"`
              : "All Result"}
          </span>
        </Grid>
        <Grid xs={12} md={6}>
          <div className={styles.searchInputContainer}>
            <Icons.SearchIcon2 className={styles.searchIcon} />
            <input
              className={styles.searchInput}
              placeholder="Search author or publisher by name or publication house "
              onChange={(e) => setSearch(e.target.value)}
              autoFocus
              value={search}
            />
          </div>
        </Grid>
      </Grid>

      <div className={styles.gridsContainer}>
        <Box className={styles.boxContainer}>
          <Tabs
            value={activeTab}
            onChange={handleChange}
            className={styles.tab}
            variant="scrollable"
            scrollButtons="auto"
            TabIndicatorProps={{
              style: {
                backgroundColor: "black",
              },
            }}
            sx={{
              background: "white",
              padding: "0px 14px",
            }}
          >
            {tabs?.map((item: any, index: any) => {
              return (
                <Tab
                  label={
                    <div className={classNames(styles.tabs)}>
                      <label
                        className={classNames(
                          styles.tabLabel,
                          activeTab === item?.value && styles.active
                        )}
                      >
                        {" "}
                        {item?.label}
                      </label>
                    </div>
                  }
                  sx={{ padding: "0px" }}
                />
              );
            })}
          </Tabs>
          <div
            style={{ borderBottom: "2px solid #e4e4e4", marginTop: "-2px" }}
          ></div>
        </Box>

        <Grid container spacing={4} sx={{ marginTop: "10px" }}>
          {loader
            ? Array.from({ length: 8 }).map((loader) => {
                return (
                  <Grid item xs={12} md={4} lg={3}>
                    <Loaders />
                  </Grid>
                );
              })
            : activeTab === tabsEnum.publishers
            ? publishers?.map((item) => {
                return <PartnerCard item={item} isPublisher={true} />;
              })
            : authors?.map((item) => {
                return <PartnerCard item={item} isAuthor={true} />;
              })}
        </Grid>
      </div>
    </div>
  );
}

export default SearchPartners;

const Loaders = () => {
  return (
    <div className={styles.singleLoader}>
      <Skeleton variant="circular" width={120} height={120} />
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Skeleton
          variant="text"
          width={200}
          height={40}
          sx={{ marginTop: "10px" }}
        />
        <Skeleton variant="text" width={200} height={40} />
      </div>
      <div
        style={{
          display: "flex",
          gap: "24px",
          justifyContent: "center",
          marginTop: "12px",
        }}
      >
        <Skeleton variant="rounded" width={50} height={50} />
        <Skeleton variant="rounded" width={50} height={50} />{" "}
      </div>
    </div>
  );
};

const PartnerCard = ({ item, isPublisher, isAuthor }: any) => {
  const [backgroundColors, setBackgroundColors] = useState<{
    [key: string]: string;
  }>({});
  const colors = ["#E1FCFF", "#FFEBFF", "#FFF7EB", "#FDFFEB", "#FFF2FA"];

  const getRandomColor = (publisherName: string) => {
    // If the color for this publisher is already set, return it
    if (backgroundColors[publisherName]) {
      return backgroundColors[publisherName];
    }

    // Otherwise, assign a new random color
    const randomColor = colors[Math.floor(Math.random() * colors.length)];
    setBackgroundColors((prevColors) => ({
      ...prevColors,
      [publisherName]: randomColor,
    }));

    return randomColor;
  };
  return (
    <Grid item xs={12} md={4} lg={3}>
      <div
        style={{
          backgroundColor: getRandomColor(item.name),
        }}
        className={styles.singlePublisherContainer}
      >
        {isAuthor && item?.publishingHouse && (
          <div className={styles.publishingHouseTag}>
            {item?.publishingHouse}
          </div>
        )}
        <img
          src={Images.UserPlaceholderImage}
          alt="Publisher-pic"
          className={styles.publisherPhoto}
          style={isAuthor ? { marginTop: "10px" } : {}}
        />
        <div
          style={{
            flexDirection: "column",
            display: "flex",
            alignItems: "center",
            gap: "6px",
          }}
        >
          <span className={styles.publisherName}>{item?.name}</span>
          {isPublisher && item?.publishingHouse && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <img
                src={Images.UserPlaceholderImage}
                alt="Publisher-pic"
                className={styles.publishingHousePhoto}
              />
              <span className={styles.publishingHouse}>
                {item?.publishingHouse}
              </span>
            </div>
          )}
        </div>

        <div style={{ display: "flex", gap: "18px" }}>
          <div className={styles.singleStats}>
            <div className={styles.statsCount}>
              {item?.books ? item?.books?.toLocaleString().toLocaleString() : 0}
            </div>
            <div className={styles.statsHeading}>Total Books</div>
          </div>
          {item?.linked && isPublisher ? (
            <div className={styles.singleStats}>
              <div className={styles.statsCount}>{item?.linked}</div>
              <div className={styles.statsHeading}>Linked Accounts</div>
            </div>
          ) : null}
        </div>
      </div>
    </Grid>
  );
};
